"use client";

import { useTranslations } from "next-intl";
import { Link } from "@/i18n/routing";

export default function FooterProducts() {
  const t = useTranslations("footer.products");

  return (
    <div className="flex flex-col gap-2 text-sm">
      <p className="font-medium">{t("title")}</p>
      <Link href="/products/proxies/residential-proxies" className="text-sm text-muted-foreground">
        {t("residential")}
      </Link>
      <Link href="/products/proxies/datacenter-proxies" className="text-sm text-muted-foreground">
        {t("datacenter")}
      </Link>
      <Link href="/products/proxies/isp-proxies" className="text-sm text-muted-foreground">
        {t("isp")}
      </Link>
    </div>
  );
}
